import { OfferStateList } from '@zurich/api/contract';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
export const approvalStateUtils = createArrayUtils(OfferStateList, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'contract:approvalState',
    createDefaultValue: () => 'applicationApprovalPending',
});
